import axios from 'axios';
import { config } from '../../config';

export default {
    namespaced: true, // ← IMPORTANTE: Activa el namespacing para este módulo
    actions: {
        async diaHabilitado_getAll() {
            return new Promise((resolve, reject) => {
                axios.get(config.apiUrl + '/dia-habilitado/get-all')
                    .then(
                        response => {
                            resolve(response);
                        })
                    .catch(error => {
                        reject(error.response);
                    });
            });
        },
        async diaHabilitado_getHabilitados(_, formData) {
            return new Promise((resolve, reject) => {
                axios.get(config.apiUrl + '/dia-habilitado/get-habilitados'+(formData.client ? '?client=true' : '') )
                    .then(
                        response => {
                            resolve(response);
                        })
                    .catch(error => {
                        reject(error.response);
                    });
            });
        },
        async diaHabilitado_updateStore(_, formData) {
            return new Promise((resolve, reject) => {
                axios.post(config.apiUrl + '/dia-habilitado/update-store', formData)
                    .then(
                        response => {
                            resolve(response);
                        })
                    .catch(error => {
                        reject(error.response);
                    });
            });
        },
        async diaHabilitado_delete(_, formData) {
            return new Promise((resolve, reject) => {
                axios.post(config.apiUrl + '/dia-habilitado/delete', formData)
                    .then(
                        response => {
                            resolve(response);
                        })
                    .catch(error => {
                        reject(error.response);
                    });
            });
        },
        async diaHabilitado_restore(_, formData) {
            return new Promise((resolve, reject) => {
                axios.post(config.apiUrl + '/dia-habilitado/restore', formData)
                    .then(
                        response => {
                            resolve(response);
                        })
                    .catch(error => {
                        reject(error.response);
                    });
            });
        },
    }
}